<template>
  <div class="purchase-order-details">
    <v-row>
      <v-col cols="6" md="8">
        <h1 class="text-left mx-4">Purchase Order : {{ purchase_order.order_number }} </h1>
        <p class="red--text mx-4 text-left" v-if="purchase_order.status == 3">Cannot edit since the GRN for this PO has been already issued.</p>

      </v-col>
      <v-col cols="6" md="4">
          <v-btn
                color="primary"
                outlined
                rounded
                small
                v-if="currentUser.privileges.canEditPurchaseOrderDetails"
                :to="{ name: 'EditPurchaseOrder', params: { po_id: $route.params.po_id } }"
                :disabled="purchase_order.status==3"
            >
                Edit
                <span class="hidden-sm-and-down ml-1 edit-order">Purchase Order</span>
            </v-btn>
      </v-col>
    </v-row>

    <v-container class="mx-2 my-0">
        <v-row>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{  purchase_order.user? purchase_order.user.full_name : "-" }}</h3>
                <p class="mb-0 text-left">User</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">
                    <router-link
                        :to="{name: 'StoreItemDetails', params: { store_id: purchase_order.store_item.store.id, item_id: purchase_order.store_item.id }}"
                    >
                        <span id="item-name">{{ purchase_order.store_item.item_name }}</span>
                    </router-link>
                </h3>
                <p class="mb-0 text-left">Store Item</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ moment(purchase_order.created).format('D MMMM, YYYY') }}</h3>
                <p class="mb-0 text-left">PO Date</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ purchase_order.quantity }} {{ purchase_order.store_item.usage_unit }}</h3>
                <p class="mb-0 text-left">Quantity</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ currencyFormat(purchase_order.unit_price) }}</h3>
                <p class="mb-0 text-left">Unit Price</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ currencyFormat(purchase_order.total_amount) }}</h3>
                <p class="mb-0 text-left">Total Price</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ purchase_order.discount }}%</h3>
                <p class="mb-0 text-left">Discount</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ purchase_order.tax }}%</h3>
                <p class="mb-0 text-left">Tax</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ purchase_order.expiry_date? moment(purchase_order.expiry_date).format('D MMMM, YYYY'): "-" }}</h3>
                <p class="mb-0 text-left">Expiry Date</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ purchase_order.supplier.supplier_name }}</h3>
                <p class="mb-0 text-left">Supplier</p>
            </v-col>
            <v-col cols="6" md="4">
                <h3 class="text-left">{{ purchase_order.creator? purchase_order.creator.full_name: "-" }}</h3>
                <p class="mb-0 text-left">Creator</p>
            </v-col>

        </v-row>
    </v-container>

    <v-row v-if="currentUser.privileges.canGenerateGRNs" justify="center" >
        <div id="grn-row"> 
            <GenerateGRN :purchase_order="purchase_order" @changedResponse="getPurchaseOrderDetails" @discardChanges="getPurchaseOrderDetails"/>
        </div>
    </v-row>

    <v-btn color="primary" outlined v-if="purchase_order.status == 3" :to="{ name: 'GRNDetails', params: { grn_id: purchase_order.issued_grn } }"> GRN Details</v-btn>
    

    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import api from "@api/index";
import { mapActions, mapGetters } from 'vuex';
import endpoints from "@api/repository";
import moment from 'moment';
import Helper from "@utils/misc";
import GenerateGRN from "@components/inventory/GenerateGRN";
import TourHelper from "@utils/tour_helper";


export default {
    name: 'PurchaseOrderDetails',
    components: {
        GenerateGRN,
    },
    data(){
        return{
            moment: moment,
            snackbar: {
                visible: false,
                text: "",
            },
            po_status_mapping: {
                1: "Pending",
                2: "Approved",
                3: "Issued",
            },
            purchase_order: {
                id: null,
                order_number: null,
                reference: null,
                user: {
                    id: null,
                    full_name: null,
                },
                store_item: {
                    id: null,
                    item_name: null,
                },
                quantity: null,
                unit_price: null,
                discount: null,
                tax: null,
                expiry_date: null,
                created: null,
                last_edited: null,
                status: null,
                supplier: null,
                institution: null,
            },
        };
    },
    computed: {
        ...mapGetters(["currentUser", "accessToken", "isLoading"]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },

    },
    methods: {
        ...mapActions(["setLoading"]),

        handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Purchase Order Details", description: "View more about an order in this section", videoLink: "https://youtube.com"});
        steps.push({id: '2', title: "GRN", description: "Generate a GRN for a particular order", el: '#item-name'});
        TourHelper.startTour(this, "purchase__orders__details", steps);
        },
        
        async getPurchaseOrderDetails(){
            var url = endpoints.purchaseOrders + this.$route.params.po_id + "/";
            this.purchase_order = await api.call(this.essentials, url);
        },

        // handles api errors
        async handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                console.log(err.response);
            } else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },

        // changedResponse(response){
        //     this.purchase_order = response;
        // },

        currencyFormat(amount){
            return Helper.currencyFormat(amount);
        },

        formattedDate(date) {
            if (!date) return "";
            return moment(date).format("D MMM YYYY");
        },
    },
    created(){
        this.getPurchaseOrderDetails();
        this.handleTour();
    }
}
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>